// 样板系统相关服务
import api from './api';

// API 已经在 api.js 中配置了请求头和认证令牌

// 获取所有样板
export const getPatterns = async (categoryId = null, page = 1, pageSize = 10) => {
  try {
    let url = `/patterns?page=${page}&pageSize=${pageSize}`;
    if (categoryId) {
      url += `&categoryId=${categoryId}`;
    }
    
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('获取样板列表失败:', error);
    throw error;
  }
};

// 获取单个样板详情
export const getPatternById = async (id) => {
  try {
    const response = await api.get(`/patterns/${id}`);
    return response.data;
  } catch (error) {
    console.error('获取样板详情失败:', error);
    throw error;
  }
};

// 创建新样板
export const createPattern = async (patternData) => {
  try {
    const response = await api.post(`/patterns`, patternData);
    return response.data;
  } catch (error) {
    console.error('创建样板失败:', error);
    throw error;
  }
};

// 更新样板
export const updatePattern = async (patternData) => {
  try {
    const response = await api.put(`/patterns`, patternData);
    return response.data;
  } catch (error) {
    console.error('更新样板失败:', error);
    throw error;
  }
};

// 删除样板
export const deletePattern = async (id) => {
  try {
    const response = await api.delete(`/patterns/${id}`);
    return response.data;
  } catch (error) {
    console.error('删除样板失败:', error);
    throw error;
  }
};

// 获取所有样板分类
export const getPatternCategories = async () => {
  try {
    const response = await api.get(`/pattern-categories`);
    return response.data;
  } catch (error) {
    console.error('获取样板分类失败:', error);
    throw error;
  }
};

// 创建样板分类
export const createPatternCategory = async (categoryData) => {
  try {
    const response = await api.post(`/pattern-categories`, categoryData);
    return response.data;
  } catch (error) {
    console.error('创建样板分类失败:', error);
    throw error;
  }
};

// 更新样板分类
export const updatePatternCategory = async (categoryData) => {
  try {
    const response = await api.put(`/pattern-categories`, categoryData);
    return response.data;
  } catch (error) {
    console.error('更新样板分类失败:', error);
    throw error;
  }
};

// 删除样板分类
export const deletePatternCategory = async (id) => {
  try {
    const response = await api.delete(`/pattern-categories/${id}`);
    return response.data;
  } catch (error) {
    console.error('删除样板分类失败:', error);
    throw error;
  }
};

// 按代码搜索样板
export const searchPatternByCode = async (code) => {
  try {
    const response = await api.get(`/patterns/search/code?code=${encodeURIComponent(code)}`);
    return response.data;
  } catch (error) {
    console.error('按代码搜索样板失败:', error);
    throw error;
  }
};

// 按图像搜索样板
export const searchPatternByImage = async (imageData) => {
  try {
    const response = await api.post(`/patterns/search/image`, { imageData });
    return response.data;
  } catch (error) {
    console.error('按图像搜索样板失败:', error);
    throw error;
  }
};

// 刷新所有样板的向量特征
export const refreshPatternVectors = async () => {
  try {
    const response = await api.post(`/patterns/refresh-vectors`);
    return response.data;
  } catch (error) {
    console.error('刷新样板向量失败:', error);
    throw error;
  }
};
